<template>
    <div>
        <el-page-header @back="goBack" content="碎片活动奖品统计"></el-page-header>
        <el-card style="margin-top: 20px; font-size: 17px"  shadow="never">
            <div >
                <i class="el-icon-search"></i>
                <span>筛选搜索</span>
                <el-button
                        size="small"
                        style="position: relative; left: 1200px;"
                        type="primary"
                        @click="queryDailyActSum"
                        >
                    查询结果
                </el-button>
            </div>
            <div style="margin-top: 15px">
                <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                    <el-form-item label="日期：">
                        <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>&emsp;&emsp;
                    </el-form-item>
                    <el-form-item label="物品名称：">
                    <el-select v-model="queryData.prizeIds" placeholder="请选择"  multiple>
                        <el-option v-for="prize in Prizes"
                                   :key="prize.id"
                                   :label="prize.name"
                                   :value="prize.id"></el-option>
                    </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card style="margin-top: 0;font-size: 17px" shadow="never">
            <i class="el-icon-tickets"></i>
            <span>数据列表</span>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="list"
                      style="width: 100%"
                      :header-cell-style="{background:'#282828'}"
                      border>
                <el-table-column label="时间日期" prop="createdt" align="center"></el-table-column>
                <el-table-column label="物品名称" prop="prizeName"  align="center"></el-table-column>
                <el-table-column label="发放数" prop="offer" align="center"></el-table-column>
                <el-table-column label="发放用户数" prop="offeruser" align="center"></el-table-column>
                <el-table-column label="人均发放数" align="center">
                 <template slot-scope="scope">
                     {{scope.row.offer/scope.row.offeruser}}
                 </template>
                </el-table-column>
                <el-table-column label="详情" align="center">
                    <template slot-scope="scope">
                    <el-button type="primary" plain @click="showDetails(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
        <el-dialog title="碎片发放详情" center :visible.sync="dialogVisible">
            <el-table :data="pieceList">
                <el-table-column property="prizeid" label="编号" width="150"></el-table-column>
                <el-table-column property="name" label="名称" width="150"></el-table-column>
                <el-table-column property="weight" label="物品权重" width="200"></el-table-column>
                <el-table-column label="当天发放数">
                    <template slot-scope="scope">
                        {{scope.row.todaytotaloffer===undefined? 0:scope.row.todaytotaloffer}}
                    </template>
                </el-table-column>
                <el-table-column  label="人均拥有数">
                    <template slot-scope="scope">
                        {{(scope.row.totaloffer/scope.row.offeruser).toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column  label="人均每天获得数">
                    <template slot-scope="scope">
                        {{scope.row.todayofferuser === undefined || scope.row.todaytotaloffer === undefined? 0:(scope.row.todaytotaloffer/scope.row.todayofferuser).toFixed(2)}}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import {
        allSelectData,
        searchDailyActivitySummary,
        searchPieceSummary,
    } from "@/http/api";
    import utils from "@/utils";

    export default {
        name: "PieceActivitySummary",
        data(){
            return{
                queryData: {
                    activityId :1,
                    timeDate: ['', ''],
                    prizeIds: [-1]
                },
                queryPieceData: {
                    activityId :1,
                    createDt: null,
                    prizeId: null,
                    ids:null
                },
                dialogVisible: false,
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                list:[],
                pieceList:[],
                Prizes: [],
            }
        },
        methods:{
            goBack() {
                this.$router.push({path: '/ActivitySummary'})
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryDailyActSum();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryDailyActSum();
            },
            showDetails(row){
                this.dialogVisible = true;
                this.queryPieceData.prizeId = row.id;
                this.queryPieceData.createDt = row.createdt;
                searchPieceSummary(this.queryPieceData).then(resp => {
                    this.pieceList = resp.data.info.list.sort((a,b) => (a.prizeId - b.prizeId));
                    this.headers = {Authorization: this.$store.state.user.token};
                });

            },
            queryDailyActSum(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.queryData.ids = (this.queryData.prizeIds.indexOf(-1)!==-1 || this.queryData.prizeIds.length===0) ?null:this.queryData.prizeIds.toString();
                searchDailyActivitySummary(this.queryData).then(resp => {
                    this.list = resp.data.info.list;
                    this.page.totalElements = resp.data.info.totalElements;
                    this.headers = {Authorization: this.$store.state.user.token};
                });
            }
        },
    created() {
        this.queryData.timeDate = [utils.TodayUtil.getYesterday(), utils.TodayUtil.getNow()];
        allSelectData().then(resp => {
            this.Prizes = resp.data.info.prizes.filter(vo => vo.type === 2);
            this.Prizes.unshift({"id": -1, "name": "全部"});
        });
        this.queryDailyActSum();
    },

    }
</script>

<style scoped>

</style>